<template>
  <nav class="panel service">
    <!--<div class="panel-heading">-->
      <!--<slot name="header"></slot>-->
    <!--</div>-->
    <div class="panel-block">
      <div class="field service__title">
        <p class="heading">Title</p>
        <div class="control is-small">
          <input type="text" name="title" class="input is-small" placeholder="Title" v-model="service.title">
        </div>
      </div>
    </div>
    <div class="panel-block">
      <span class="panel-icon">
        <i :class="service.icon"></i>
      </span>
      <div class="field">
        <div class="control">
          <input class="input is-small" type="text" placeholder="Icon" v-model="service.icon">
        </div>
      </div>
    </div>
    <div class="panel-block">
      <div class="field service__description">
        <p class="heading">Short Description</p>
        <div class="control is-small">
          <textarea class="textarea is-small" type="text" v-model="service.description"></textarea>
        </div>
      </div>
    </div>
    <div class="panel-block">
      <div class="field service__description">
        <p class="heading">Details</p>
        <div class="control is-small">
          <textarea class="textarea is-small" type="text" v-model="service.details"></textarea>
        </div>
      </div>
    </div>
    <div class="panel-block">
      <div class="field service__description">
        <div class="control is-small">
          <label class="checkbox">
            <input type="checkbox" v-model="service.free">
            Free
          </label>
        </div>
      </div>
    </div>
    <div class="panel-block">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="field">
              <p class="heading">link label</p>
              <div class="control is-small">
                <input type="text" name="linkLabel" class="input is-small" placeholder="label" v-model="service.linkLabel">
              </div>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="field">
              <p class="heading">link</p>
              <div class="control is-small">
                <input type="text" name="link" class="input is-small" placeholder="http://www.yourlinkhere.com" v-model="service.link">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-block">
      <slot name="footer"></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'user-service-edit',
  props: {
    service: {
      type: Object,
      default () {
        return {
          title: '',
          free: false,
          icon: '',
          description: '',
          details: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .service {
    .field {
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/ServiceEditCard.vue